export default "__VITE_ASSET__dc971017__"